module.exports = __webpack_public_path__ + "img/green-bottom-arrow.9a9189c7.svg";